// extracted by mini-css-extract-plugin
export default {"greeting":"Greeting_greeting__PbwJY","hello":"Greeting_hello__rnz0v","welcome":"Greeting_welcome__krwdP","animationRoll":"Greeting_animationRoll__rS22a"};